export const SearcherNameToId = {
    searcherFerryHotel: 'FER_HOT',
    'm-searcher-ferry-hotel': 'FER_HOT',
    FER_HOT: 'FER_HOT',
    searcherFlightHotel: 'FLI_HOT',
    'm-searcher-flight-hotel': 'FLI_HOT',
    FLI_HOT: 'FLI_HOT',
    searcherTrainHotel: 'TRA_HOT',
    'm-searcher-train-hotel': 'TRA_HOT',
    TRA_HOT: 'TRA_HOT',
    searcherTou: 'TOU',
    'm-searcher-tou': 'TOU',
    TOU: 'TOU'
};

//# sourceMappingURL=constants.js.map